import { getLogger, tracker } from 'app-components/utils/core';

const logger = getLogger('trackEventTTI.js');

export const trackEventTTI = (event, props) => {
  if (window?.requestIdleCallback) {
    tracker.timeEvent(event);
    const start = Date.now();
    window.requestIdleCallback(() => {
      const time = Math.floor(Date.now() - start);
      tracker.track(event, props);
      if (time > 500) {
        logger.warn(`TTI for ${event} is too slow: ${time}ms`);
      }
    });
  } else {
    tracker.track(event, props);
  }
};

export default trackEventTTI;
